import { Page, AircraftType, AircraftCategory } from '@flyblack/common/domains';

import { authorizedApi } from '@/services/network/authorized-api';

export const getAircraftTypes = (aircraftCategoryId: number) =>
  authorizedApi.get<Page<AircraftType>>(`/v1/aircraft-types`, { aircraftCategoryId });

export const getAircraftCategories = () =>
  authorizedApi.get<{ categories: AircraftCategory[] }>(`/v1/aircraft-categories`);
